import { createTheme } from '@mui/material/styles';

export const fontFamilies = {
  gotham:
    'Gotham, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  gothamLight:
    'Gotham-Light, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  gothamBook:
    'Gotham-Book, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  quicksand: 'Quicksand, "Trebuchet MS", Arial, sans-serif',
  cinzel: 'Cinzel, Georgia, "Times New Roman", serif',
  tenorSans: '"Tenor Sans", Georgia, "Times New Roman", serif',
  hindGuntur: 'Hind Guntur, sans-serif',
};

export const colors = {
  primary: '#33261D',
  secondary: '#29405A',
  accent: '#E05C2B',
  text: '#33261D',
  textLight: '#666',
  background: '#F5F3ED',
  whiteText: '#ffffff',
  calmBlue: '#74A9C8',
  iconBackground: '#F7F3F1',
  lightBorder: '#B4B2B2',
  hoverBackground: '#f3f5f6',
  lighthBackground: '#E6EBF0',
  mutedClay: '#2D2018',
};

export const avatarPlaceholderColors = {
  yellow: '#FFF5E5',
  skyBlue: '#E5F3FF',
  lilac: '#D9D9FF',
  rose: '#FFD9E5',
  teal: '#E5F3FF',
  mint: '#E5F3FF',
  cyan: '#E5FFFF',
  lavender: '#F0E5FF',
  coral: '#FFE5E5',
};

export const defaultTheme = createTheme({
  typography: {
    fontFamily: fontFamilies.gotham,
    h1: {
      fontFamily: fontFamilies.gotham,
      fontWeight: 400,
      color: colors.primary,
    },
    h2: {
      fontFamily: fontFamilies.gotham,
      fontWeight: 400,
      color: colors.primary,
    },
    h3: {
      fontFamily: fontFamilies.gotham,
      fontWeight: 400,
      color: colors.primary,
    },
    h4: {
      fontFamily: fontFamilies.gotham,
      fontWeight: 400,
      color: colors.primary,
    },
    h5: {
      fontFamily: fontFamilies.gotham,
      fontWeight: 400,
      color: colors.primary,
    },
    h6: {
      fontFamily: fontFamilies.gotham,
      fontWeight: 400,
      color: colors.primary,
    },
    body1: {
      fontFamily: fontFamilies.quicksand,
      fontWeight: 400,
      color: colors.primary,
    },
    body2: {
      fontFamily: fontFamilies.quicksand,
      fontWeight: 400,
      color: colors.textLight,
    },
    button: {
      fontFamily: fontFamilies.quicksand,
      fontWeight: 600,
      textTransform: 'none',
    },
    caption: {
      fontFamily: fontFamilies.quicksand,
      fontWeight: 400,
    },
    heading: {
      fontWeight: 400,
      color: colors.primary,
      fontFamily: fontFamilies.gotham,
      letterSpacing: 0.2,
      fontSize: { xs: 30, sm: 40, md: 60 },
    },
    subtext: {
      fontWeight: 400,
      fontFamily: fontFamilies.quicksand,
      fontSize: { xs: 14, md: 22 },
      textAlign: 'center',
    },
    overHeading: {
      fontWeight: 400,
      color: colors.primary,
      fontFamily: fontFamilies.gotham,
      letterSpacing: 0.2,
      fontSize: { xs: 18, sm: 20, md: 37 },
      textTransform: 'uppercase',
    },
    question: {
      fontFamily: fontFamilies.gotham,
      fontWeight: 400,
      color: colors.primary,
      lineHeight: 1.5,
    },
    option: {
      fontFamily: fontFamilies.quicksand,
      fontWeight: 400,
      color: colors.primary,
      lineHeight: 1.5,
    },
    hint: {
      fontFamily: fontFamilies.quicksand,
      fontWeight: 400,
      color: colors.textLight,
    },
    link: {
      fontFamily: fontFamilies.quicksand,
      fontWeight: 400,
      color: colors.primary,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  palette: {
    primary: {
      main: colors.secondary,
    },
    text: {
      primary: colors.primary,
      secondary: colors.textLight,
    },
    background: {
      default: colors.background,
    },
  },
});
